import styled from 'styled-components'
import { BP } from 'resources/constants'

export const Wrapper = styled.div<any>`
  max-width: 41%;
  display: flex;
  align-items: center;

  @media (max-width: ${BP.lg.min}) {
    max-width: 75%;
  }

  > div,
  > button,
  > a {
    margin-left: 10px;
  }

  .sofia-btn {
    color: #38291d;
  }

  .livbrite-btn {
    ${props => props.theme.css.buttonPrimary}
  }
`
